<template>
  <div>
    <CRow>
      <CCol col="12">
        <CAlert show color="info">
          <h4 class="alert-heading">
            <i class="fa fa-info" aria-hidden="true"></i> 주의
          </h4>
          <hr />
          <p>
            본 화면에서의 제어기 설정은 사용자의 판단에 의해 조작 및 설정되며,
            제어의 우선권은
            <span class="label scc-rounded bg-color-red">1. 제어기기</span>,
            <span class="label scc-rounded bg-color-orange">2. 사용자 제어</span
            >,
            <span class="label scc-rounded bg-color-green-dark"
              >3. 자동제어</span
            >
            순으로 가지게 됩니다.
          </p>
          <p>
            현재 페이지의
            <span class="p-1 txt-color-red" style="background: #fff">
              제어기 설정은 사용자의 판단
            </span>
            에 의한 제어로 작동하게 됨을 알려드립니다.
          </p>
        </CAlert>
      </CCol>

      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CForm inline>
              <!--              <label class="col-form-label ml-2 mr-2"></label>-->
              <CSelect
                :value.sync="inFacilityId"
                :options="inFacilityList"
                style="margin-bottom: 0; width: 97%"
                class="ml-2 ml-sm-0 w-auto-sm"
              >
              </CSelect>
              <div class="ml-auto" v-if="status != null">
                <template v-if="status.control.mode.value === 'dashboard'">
                  <CButton color="danger" disabled> 대시보드 제어중</CButton>
                  <CButton
                    color="primary"
                    class="ml-2"
                    @click="changeControlMode('site')"
                  >
                    현장 제어
                  </CButton>
                </template>
                <template v-if="status.control.mode.value === 'site'">
                  <CButton
                    color="primary"
                    @click="changeControlMode('dashboard')"
                  >
                    대시보드 제어
                  </CButton>
                  <CButton color="danger" class="ml-2" disabled>
                    현장 제어중
                  </CButton>
                </template>
              </div>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol col="12">
        <ControlCard :status.sync="status"></ControlCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import MixinsInFacility from "@/mixins/in-facility";
import ControlCard from "@/components/control/ControlCard";
import core from "@/core";
import ControlService from "@/services/control/control.service";

export default {
  name: "Control",
  components: { ControlCard },
  mixins: [MixinsInFacility()],
  data() {
    return {
      status: null
    };
  },
  methods: {
    async changeControlMode(value) {
      try {
        core.loader.show("제어중...");
        const result = await ControlService.controlNareMode(value);
        console.log("result : ", result);
        core.loader.hide();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style></style>
